import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress, Box } from "@mui/material";
import { selectCurrentUser } from "../auth/authSlice";
import { useGetWebsiteSettingsQuery } from "../../../app/websiteApiSlice";
import ModernTheme from "./themes/modern/ModernTheme";
import ClassicTheme from "./themes/classic/ClassicTheme";
import BoldTheme from "./themes/bold/BoldTheme";
import WebsitePageRenderer from "./WebsitePageRenderer";

export default function WebsiteRoot() {
  const user = useSelector(selectCurrentUser);
  const { data: settings, isLoading } = useGetWebsiteSettingsQuery();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  // Website is disabled — send logged-in users to dashboard, guests to login
  if (!settings?.enabled) {
    return <Navigate to={user ? "/dashboard" : "/login"} replace />;
  }

  // If a static home page is configured, render its content at /
  if (settings?.home_page?.slug) {
    return <WebsitePageRenderer slug={settings.home_page.slug} />;
  }

  // Default: render the theme's auto-generated landing page
  switch (settings.theme) {
    case "classic":
      return <ClassicTheme settings={settings} />;
    case "bold":
      return <BoldTheme settings={settings} />;
    case "modern":
    default:
      return <ModernTheme settings={settings} />;
  }
}
